import { render, staticRenderFns } from "./AppEmbed.vue?vue&type=template&id=24f43232&scoped=true"
import script from "./AppEmbed.vue?vue&type=script&lang=js"
export * from "./AppEmbed.vue?vue&type=script&lang=js"
import style0 from "./AppEmbed.vue?vue&type=style&index=0&id=24f43232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f43232",
  null
  
)

export default component.exports